import { createContext, useContext } from 'react';

import { EMPTY_FUNCTION } from '../../../constants';
import { ModalContextProps } from '../types';

export const ModalContext = createContext<ModalContextProps>({
  theme: {},
  is_open: false,
  identifier: 'voladeum-modal',
  onClose: EMPTY_FUNCTION,
});

export const useModalContext = () => useContext(ModalContext) as ModalContextProps;
